<script>
    import gsap from 'gsap';
    import {onMount} from "svelte";
    import {labels, mainTimeline} from "../../timelines/main-timeline";
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import MotionPathPlugin from "gsap/MotionPathPlugin";
    import MorphSVGPlugin from "gsap/MorphSVGPlugin";

    gsap.registerPlugin(MotionPathPlugin);
    gsap.registerPlugin(MorphSVGPlugin);
    gsap.registerPlugin(DrawSVGPlugin);

    const inTimeline = gsap.timeline();
    const outTimeline = gsap.timeline();
    const {pathStart, pathEnd} = labels;

    let polylinePath;

    onMount(() => {

        inTimeline
            .from('.path-circle', {
                opacity: 0,
                duration: 0.1,
            })
            .from('.path-circle', {
                cx: 576 / 2,
                cy: 360 / 2,
                duration: 1,
            }, '<');

        inTimeline
            .fromTo('.line', {
                drawSVG: '0%',
                duration: 2.5,
            }, {
                drawSVG: '100%',
            });



        outTimeline
            .from('.pole', {
                drawSVG: '0%',
                duration: 0.6,
            })
            .from('.flag', {
                scaleX: 0,
                transformOrigin: 'left',
                duration: 0.6,
            })
            .to('.path-circle', {
                scale: 0,
                duration: 0.6,
                transformOrigin: 'center'
            }, '>+=1')
            .to('.pole', {
                scale: 0,
                duration: 0.6,
                transformOrigin: '0% 100%'
            }, '<')
            .to('.flag', {
                scale: 0,
                y: '40px',
                x: '-20px',
                duration: 0.6,
                transformOrigin: '50% 100%'
            }, '<')
            .to('.line', {
                strokeWidth: 0,
                duration: 0.6,
            }, '<')
            ;

        mainTimeline.add(inTimeline, pathStart);
        mainTimeline.add(outTimeline, pathEnd + '+=1');

    });
</script>

<svg id="path" xmlns="http://www.w3.org/2000/svg" width="700px" x="600" y=200 viewBox="0 0 579.54 432.04">
    <g id="Graphics">
        <polyline class="line" points="18.75 390.72 141.46 319.88 327.07 427.04 451.83 355 142.49 176.4 234.26 123.42 449.77 247.84 574.54 177 418.84 87.1"/>
        <circle class="path-circle" cx="18.75" cy="390.72" r="15.58"/>
        <circle class="path-circle" cx="416.28" cy="87.1" r="15.58"/>
        <polyline class="peachShape flag" points="424.9 18.33 441.44 9.16 457.98 0 457.98 24.43 441.44 33.88 424.9 43.33"/>
        <line class="peachLine pole" x1="416.28" y1="87.1" x2="416.28" y2="18.33"/>
    </g>
</svg>


<style>
    .line2 {
        opacity: 0;
    }

    .line {
        fill:none;
        stroke:#000;
        stroke-linecap:round;
        stroke-linejoin:round;
        stroke-width:10px;
    }

    .peachShape {
        fill:#f5d2b5;
        stroke: none;
    }

    .line,
    .peachLine {
        fill:none;
        stroke-linecap:round;
        stroke-linejoin:round;
    }

    .peachLine {
        stroke:#f5d2b5;
        stroke-width:2px;
    }

</style>
